import React, { useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

const pages = [
  "/satyagraha/page1.jpg",
  "/satyagraha/page2.jpg",
  "/satyagraha/page3.jpg",
  "/satyagraha/page4.jpg",
  "/satyagraha/page5.jpg",
  "/satyagraha/page6.jpg",
  "/satyagraha/page7.jpg",
  "/satyagraha/page8.jpg",
  "/satyagraha/page9.jpg",
  "/satyagraha/page10.jpg",
  "/satyagraha/page11.jpg",
  "/satyagraha/page12.jpg",
  "/satyagraha/page13.jpg",
  "/satyagraha/page14.jpg",
  "/satyagraha/page15.jpg",
  "/satyagraha/page16.jpg",
  "/satyagraha/page17.jpg",
  "/satyagraha/page18.jpg",
  "/satyagraha/page19.jpg",
  "/satyagraha/page20.jpg",
  "/satyagraha/page21.jpg",
  "/satyagraha/page22.jpg",
  "/satyagraha/page23.jpg",
  "/satyagraha/page24.jpg",
];

export default function SatyagrahaEternalJourney() {
  const book = useRef(null);
  const [page, setPage] = useState(1);

  const nextPage = () => {
    book.current?.pageFlip().flipNext();
  };

  const prevPage = () => {
    book.current?.pageFlip().flipPrev();
  };

  return (
    <>
      <Helmet>
        <title>Satyagraha – An Eternal Journey | Gandhi Mandela Foundation</title>
        <meta name="description" content="Satyagraha – An Eternal Journey" />
      </Helmet>
      <Header />

      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Satyagraha– An Eternal Journey</span>
          </div>
          <h1>Satyagraha– An Eternal Journey</h1>
        </div>
      </section>

      <section className="section">
        <div className="container flipbook-container">

          <HTMLFlipBook
            ref={book}
            width={500}
            height={700}
            size="stretch"
            minWidth={280}
            maxWidth={700}
            minHeight={400}
            maxHeight={900}
            showCover={true}
            mobileScrollSupport={true}
            drawShadow={true}
            onFlip={(e) => setPage(e.data + 1)}
          >
            {pages.map((img, index) => (
              <div className="book-page" key={index}>
                <img src={img} alt={`Page ${index + 1}`} />

                <div className="page-corner top">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>

                <div className="page-corner bottom">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
              </div>
            ))}
          </HTMLFlipBook>

          <div className="page-count">
            Page {page} of {pages.length}
          </div>

          <div className="swipe-hint">
            <i className="fa-solid fa-hand-point-up"></i>
            Swipe or use the buttons below to turn pages
          </div>

          <div className="mobile-controls">
            <button onClick={prevPage}>
              <i className="fa-solid fa-chevron-left"></i> Previous
            </button>

            <button onClick={nextPage}>
              Next <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}